const validateViolationImage = ({ faceModel, image }) => {
  try {
    if (!image || !faceModel) return false;

    // Check if video has valid dimensions
    const width = image.videoWidth || image.width;
    const height = image.videoHeight || image.height;
    if (!width || !height || width === 0 || height === 0) return false;

    const result = faceModel.detectForVideo(image, performance.now());
    const hasFaces = result?.faceLandmarks?.length > 0;

    return !hasFaces;
  } catch (error) {
    console.error('Face detection error:', error);
    return false;
  }
};

export default validateViolationImage;
